import Vue from "vue";
import VueRouter from "vue-router";
import auth_jwt_useJwt from '@/auth/jwt/useJwt';
import vuei18n from 'vue-i18n';




// const titleLocales = { ru, en, es };

function checkToken() {
  const isUserLoggedIn = localStorage.getItem(auth_jwt_useJwt.jwtConfig.storageTokenKeyName);
  return !!isUserLoggedIn;
}
const LANGUAGES_STRING = ":lang(en|de|fr|pt)?";
async function protectedRoute(to, from, next) {
  if (checkToken()) {
    next();
  } else {
    next("/auth/login");
  }
}
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  base: "/",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
    path: `/${LANGUAGES_STRING}`,
    component: () => import("@/views/p2p-buy/Buy.vue"),
    children: [{
      path: "",
      name: "home",
      component: () => import("@/views/p2p-buy/Buy.vue"),
      meta: {
        pageTitle: "Home",
        breadcrumb: [{
          text: "Home",
          active: true
        }]
      }
    }],
    meta: {
      pageTitle: "Home",
      breadcrumb: [{
        text: "Home",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/transactionHistory`,
    name: "transactionHistory",
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/TransactionHistory.vue"),
    meta: {
      pageTitle: "TransactionHistory",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "TransactionHistory",
        active: true
      }]
    }
  }, {
    path: "/transactionHistory",
    component: () => import("@/views/wallet/TransactionHistory.vue"),
    meta: {
      pageTitle: "TransactionHistory",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "TransactionHistory",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/profile`,
    name: "profile",
    beforeEnter: protectedRoute,
    component: () => import("@/views/profile/Profile.vue"),
    meta: {
      pageTitle: "Profile",
      breadcrumb: [{
        text: "Profile",
        active: true
      }]
    }
  }, {
    path: "/profile",
    beforeEnter: protectedRoute,
    component: () => import("@/views/profile/Profile.vue"),
    meta: {
      pageTitle: "Profile",
      breadcrumb: [{
        text: "Profile",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/verification`,
    name: "verification",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/StartKYC.vue"),
    meta: {
      pageTitle: "Verification",
      breadcrumb: [{
        text: "Verification",
        active: true
      }]
    }
  }, {
    path: "/verification",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/StartKYC.vue"),
    meta: {
      pageTitle: "Verification",
      breadcrumb: [{
        text: "Verification",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/p2p-buy`,
    name: "buy",
    beforeEnter: protectedRoute,
    component: () => import("@/views/p2p-buy/Buy.vue"),
    meta: {
      pageTitle: "Buy",
      breadcrumb: [{
        text: "Buy",
        active: true
      }]
    }
  }, {
    path: "/p2p-buy",
    beforeEnter: protectedRoute,
    component: () => import("@/views/p2p-buy/Buy.vue"),
    meta: {
      pageTitle: "Buy",
      breadcrumb: [{
        text: "Buy",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/OrderCreated/:id`,
    name: "OrderCreated",
    beforeEnter: protectedRoute,
    component: () => import("@/views/p2p-buy/OrderCreated.vue"),
    meta: {
      pageTitle: "OrderCreated",
      navActiveLink: "order",
      breadcrumb: [{
        text: "OrderCreated",
        active: true
      }]
    }
  }, {
    path: "/OrderCreated/:id",
    beforeEnter: protectedRoute,
    component: () => import("@/views/p2p-buy/OrderCreated.vue"),
    meta: {
      pageTitle: "OrderCreated",
      navActiveLink: "order",
      breadcrumb: [{
        text: "OrderCreated",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/disputeStatus/:id`,
    name: "disputeStatus",
    beforeEnter: protectedRoute,
    component: () => import("@/views/p2p-buy/DisputeStatus.vue"),
    meta: {
      pageTitle: "DisputeStatus",
      navActiveLink: "order",
      breadcrumb: [{
        text: "DisputeStatus",
        active: true
      }]
    }
  }, {
    path: "/disputeStatus/:id",
    beforeEnter: protectedRoute,
    component: () => import("@/views/p2p-buy/DisputeStatus.vue"),
    meta: {
      pageTitle: "DisputeStatus",
      navActiveLink: "order",
      breadcrumb: [{
        text: "DisputeStatus",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/login`,
    name: "auth-login",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/login",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/forgot`,
    name: "auth-forgot",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/ForgotPassword.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/forgot",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/ForgotPassword.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/resetpassword/:token`,
    name: "resetpassword",
    // beforeEnter(to, from, next) {
    //   if (checkToken()) {
    //     next("/");
    //   } else next();
    // },
    component: () => import("@/views/auth/resetpassword.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/resetpassword/:token",
    // beforeEnter(to, from, next) {
    //   if (checkToken()) {
    //     next("/");
    //   } else next();
    // },
    component: () => import("@/views/auth/resetpassword.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/reset2FA/:token`,
    name: "reset2FA",
    component: () => import("@/views/auth/EmailVerified.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/reset2FA/:token",
    component: () => import("@/views/auth/EmailVerified.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/password-update`,
    name: "password-update",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/PasswordUpdate.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/password-update",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/PasswordUpdate.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/verify-email/:email`,
    name: "verify-email",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/VerifyEmail.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/verify-email/:email",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/VerifyEmail.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/forgot-verify-email/:email`,
    name: "forgot-verify-email",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/VerifyEmail.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/forgot-verify-email/:email",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/VerifyEmail.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/2fa-verify-email`,
    name: "2fa-verify-email",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/VerifyEmail.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/2fa-verify-email",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/VerifyEmail.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/personal-information`,
    name: "personal-information",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/PersonalInformation.vue"),
    meta: {
      pageTitle: "personal-information",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "personal-information",
        active: true
      }]
    }
  }, {
    path: "/personal-information",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/PersonalInformation.vue"),
    meta: {
      pageTitle: "personal-information",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "personal-information",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/pan-verification`,
    name: "pan-verification",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/PanVerification.vue"),
    meta: {
      pageTitle: "pan-verification",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "pan-verification",
        active: true
      }]
    }
  }, {
    path: "/pan-verification",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/PanVerification.vue"),
    meta: {
      pageTitle: "pan-verification",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "pan-verification",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/selfie-verification`,
    name: "selfie-verification",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/SelfieVerification.vue"),
    meta: {
      pageTitle: "selfie-verification",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "selfie-verification",
        active: true
      }]
    }
  }, {
    path: "/selfie-verification",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/SelfieVerification.vue"),
    meta: {
      pageTitle: "selfie-verification",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "selfie-verification",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/under-review`,
    name: "under-review",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/UnderReview.vue"),
    meta: {
      pageTitle: "under-review",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "under-review",
        active: true
      }]
    }
  }, {
    path: "/under-review",
    beforeEnter: protectedRoute,
    component: () => import("@/views/kyc/UnderReview.vue"),
    meta: {
      pageTitle: "under-review",
      navActiveLink: "verification",
      breadcrumb: [{
        text: "under-review",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/security`,
    name: "security",
    beforeEnter: protectedRoute,
    component: () => import("@/views/security/Security.vue"),
    meta: {
      pageTitle: "Security",
      breadcrumb: [{
        text: "Security",
        active: true
      }]
    }
  }, {
    path: "/security",
    beforeEnter: protectedRoute,
    component: () => import("@/views/security/Security.vue"),
    meta: {
      pageTitle: "Security",
      breadcrumb: [{
        text: "Security",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/wallet`,
    name: "wallet",
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/Wallet.vue"),
    meta: {
      pageTitle: "Wallet",
      breadcrumb: [{
        text: "Wallet",
        active: true
      }]
    }
  }, {
    path: "/wallet",
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/Wallet.vue"),
    meta: {
      pageTitle: "Wallet",
      breadcrumb: [{
        text: "Wallet",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/deposit`,
    name: "deposit",
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/Deposit.vue"),
    meta: {
      pageTitle: "Deposit",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "Deposit",
        active: true
      }]
    }
  }, {
    path: `/deposit`,
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/Deposit.vue"),
    meta: {
      pageTitle: "Deposit",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "Deposit",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/withdraw`,
    name: "withdraw",
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/Withdraw.vue"),
    meta: {
      pageTitle: "Withdraw",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "Withdraw",
        active: true
      }]
    }
  }, {
    path: `/withdraw`,
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/Withdraw.vue"),
    meta: {
      pageTitle: "Withdraw",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "Withdraw",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/transactionHistory`,
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/TransactionHistory.vue"),
    meta: {
      pageTitle: "TransactionHistory",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "TransactionHistory",
        active: true
      }]
    }
  }, {
    path: "/transactionHistory",
    beforeEnter: protectedRoute,
    component: () => import("@/views/wallet/TransactionHistory.vue"),
    meta: {
      pageTitle: "TransactionHistory",
      navActiveLink: "wallet",
      breadcrumb: [{
        text: "TransactionHistory",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/profile`,
    beforeEnter: protectedRoute,
    component: () => import("@/views/profile/Profile.vue"),
    meta: {
      pageTitle: "Profile",
      breadcrumb: [{
        text: "Profile",
        active: true
      }]
    }
  }, {
    path: "/profile",
    beforeEnter: protectedRoute,
    component: () => import("@/views/profile/Profile.vue"),
    meta: {
      pageTitle: "Profile",
      breadcrumb: [{
        text: "Profile",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/payment`,
    name: "payment",
    beforeEnter: protectedRoute,
    component: () => import("@/views/payment/Payment.vue"),
    meta: {
      pageTitle: "Payment",
      breadcrumb: [{
        text: "Payment",
        active: true
      }]
    }
  }, {
    path: "/payment",
    beforeEnter: protectedRoute,
    component: () => import("@/views/payment/Payment.vue"),
    meta: {
      pageTitle: "Payment",
      breadcrumb: [{
        text: "Payment",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/set-new-password`,
    name: "set-new-password",
    beforeEnter: protectedRoute,
    component: () => import("@/views/profile/SetNewPassword.vue"),
    meta: {
      pageTitle: "Set New Password",
      breadcrumb: [{
        text: "Set New Password",
        active: true
      }]
    }
  }, {
    path: "/set-new-password",
    beforeEnter: protectedRoute,
    component: () => import("@/views/profile/SetNewPassword.vue"),
    meta: {
      pageTitle: "Set New Password",
      breadcrumb: [{
        text: "Set New Password",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/email-verified/:token`,
    name: "email-verified",
    component: () => import("@/views/auth/EmailVerified.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/email-verified/:token",
    component: () => import("@/views/auth/EmailVerified.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/password-updated",
    name: "reset-password-updated",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/resetPasswordUpdated.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/register",
    name: "auth-register",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/Register.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/register`,
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/Register.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/forgot`,
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/ForgotPassword.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/forgot",
    beforeEnter(to, from, next) {
      if (checkToken()) {
        next("/");
      } else next();
    },
    component: () => import("@/views/auth/ForgotPassword.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/error-404`,
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/order`,
    name: "order",
    beforeEnter: protectedRoute,
    component: () => import("@/views/order/Order.vue"),
    meta: {
      pageTitle: "Order",
      breadcrumb: [{
        text: "Order",
        active: true
      }]
    }
  }, {
    path: "/order",
    beforeEnter: protectedRoute,
    component: () => import("@/views/order/Order.vue"),
    meta: {
      pageTitle: "Order",
      breadcrumb: [{
        text: "Order",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/my-ads`,
    name: "my-ads",
    beforeEnter: protectedRoute,
    component: () => import("@/views/myads/ads.vue"),
    meta: {
      pageTitle: "my-ads",
      breadcrumb: [{
        text: "my-ads",
        active: true
      }]
    }
  }, {
    path: "/my-ads",
    beforeEnter: protectedRoute,
    component: () => import("@/views/myads/ads.vue"),
    meta: {
      pageTitle: "my-ads",
      breadcrumb: [{
        text: "my-ads",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/ad-order/:id`,
    name: "ad-order",
    beforeEnter: protectedRoute,
    component: () => import("@/views/myads/adsOrder.vue"),
    meta: {
      pageTitle: "ad-order",
      navActiveLink: "my-ads",
      breadcrumb: [{
        text: "ad-order",
        active: true
      }]
    }
  }, {
    path: "/ad-order/:id",
    beforeEnter: protectedRoute,
    component: () => import("@/views/myads/adsOrder.vue"),
    meta: {
      pageTitle: "ad-order",
      navActiveLink: "my-ads",
      breadcrumb: [{
        text: "ad-order",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/ad-post`,
    name: "ad-post",
    beforeEnter: protectedRoute,
    component: () => import("@/views/myads/postAd.vue"),
    meta: {
      pageTitle: "ad-post",
      navActiveLink: "my-ads",
      breadcrumb: [{
        text: "ad-post",
        active: true
      }]
    }
  }, {
    path: "/ad-post",
    beforeEnter: protectedRoute,
    component: () => import("@/views/myads/postAd.vue"),
    meta: {
      pageTitle: "ad-post",
      navActiveLink: "my-ads",
      breadcrumb: [{
        text: "ad-post",
        active: true
      }]
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/login-with-google`,
    name: "login-with-google",
    component: () => import("@/views/auth/LoginWithGoogle.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/login-with-google",
    component: () => import("@/views/auth/LoginWithGoogle.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: `/${LANGUAGES_STRING}/auth/login-with-apple`,
    name: "login-with-apple",
    component: () => import("@/views/auth/LoginWithApple.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "/auth/login-with-apple",
    component: () => import("@/views/auth/LoginWithApple.vue"),
    meta: {
      layout: "full"
    }
  }, {
    path: "*",
    redirect: "error-404"
  }]
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

// router.beforeEach((to, form, next) => {
//   const currentLocale = "en";

//   // Dynamic assign page title
//   const newTitle =
//     titleLocales[currentLocale][to.name] ||
//     titleLocales[currentLocale].DEFAULT_TITLE;

//   document.title = newTitle;

//   document
//     .querySelector('meta[property="og:title"]')
//     .setAttribute("content", newTitle);

//   next();
// });
export default (router);

